export default "__VITE_ASSET__BVWlzR73__"